<template>
  <div class="helix-creator">
    <div class="helix-creator-info">
      <div class="hxp-creator-left-part">
        <h4>Full creative freedom</h4>
        <h1>So many ways to earn</h1>

        <img
          v-motion
          src="img/creatortech-min.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>

      <div class="hxp-creator-right-part">
        <div class="card">
          <div class="card-title">
            <img src="img/hxp-creator-tech-min.png" alt="" />
            <h1>
              Exclusive <br />
              Content
            </h1>
            <p>
              Fans unlock access to exclusive videos and behind the scenes
              content.
            </p>
          </div>
        </div>
        <div class="card">
          <div class="card-title">
            <img src="img/hxp-creator-tech-min.png" alt="" />
            <h1>
              Fan <br />
              Shoutouts
            </h1>
            <p>Fans can requests unique video or audio messages.</p>
          </div>
        </div>
        <div class="card">
          <div class="card-title">
            <img src="img/hxp-creator-tech-min.png" alt="" />
            <h1>
              Fan <br />
              Community
            </h1>
            <p>Fans pay to join an exclusive community.</p>
          </div>
        </div>
        <div class="card">
          <div class="card-title">
            <img src="img/hxp-creator-tech-min.png" alt="" />
            <h1>
              Sell <br />
              Merch
            </h1>
            <p>Easily offer merch to your fans from your own website.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.helix-creator {
  width: 100%;
  background-color: black;
}

.helix-creator-info {
  width: 71rem;
  margin: auto;
  padding-top: 7rem;
  padding-bottom: 7rem;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  border-left: 2px solid #ff5f8f;
}

.hxp-creator-left-part h4 {
  font-weight: 700;
  font-size: 1.5rem;
  padding-left: 25px;
  padding-top: 1rem;
  color: white;
}

.hxp-creator-left-part h1 {
  color: #ff5f8f;
  line-height: 1.2;
  font-size: 4rem;
  font-weight: 800;
  margin-left: -2px;
  padding-left: 1.45rem;
  border-left: 2px solid white;
}

.hxp-creator-left-part li {
  width: 100%;
  align-items: center;
  font-size: 1rem;
  top: -10rem;
  line-height: 1.5;
  margin-bottom: 20px;
  margin-left: 1.45rem;
  margin-right: 30px;
  padding: 0px 20px 0px 40px;
  list-style: none;
  background-image: url('/img/check-list-cc.svg');
  background-repeat: no-repeat;
  background-position: 0% 20%;
  background-size: 1rem;
}

.hxp-creator-left-part img {
  width: 80%;
  padding-top: 2rem;
  display: block;
  margin: auto;
}

.hxp-cards-left,
.hxp-cards-right {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}

.card {
  display: grid;
  border-radius: 10px;
  grid-template-columns: 1fr;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.card-title {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 0;
  padding: 2rem;
}

.card-title img {
  width: 15% !important;
  display: block;
}

.card-title h1 {
  font-size: 1.3rem;
  font-weight: 700;
}

.card-title p {
  line-height: 1.5;
  font-weight: 500;
  opacity: 0.6;
}

.hxp-creator-right-part {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

@media only screen and (max-width: 1400px) {
  .helix-creator-info {
    width: 60rem;
  }
}

@media only screen and (max-width: 1050px) {
  .helix-creator-info {
    width: 40rem;
    grid-template-columns: 1fr;
  }

  .hxp-creator-right-part img {
    margin-top: 2rem;
  }
}

@media only screen and (max-width: 650px) {
  .helix-creator-info {
    width: 90%;
    border-left: none;
  }

  .hxp-creator-left-part h4 {
    font-size: 1rem;
    padding-left: 0;
    margin-left: 0;
  }

  .hxp-creator-left-part h1 {
    font-size: 2rem;
    border-left: none;
    margin-left: 0;
    padding-left: 0;
  }

  .hxp-creator-left-part p {
    margin-left: 0;
    padding-left: 0;
  }

  .hxp-creator-logos {
    margin-left: 0;
    padding-left: 0;
  }

  .hxp-creator-right-part {
    width: 100%;
  }

  .hxp-creator-right-part img {
    width: 90%;
  }

  .hxp-creator-left-part li {
    margin-left: 0;
  }

  .hxp-creator-right-part {
    grid-template-columns: 1fr;
  }

  .card-title {
    gap: 1rem;
  }

  .card-title img {
    margin-top: 0;
    width: 5% !important;
  }
}
</style>
